module App.Dashboard {
	angular
		.module('dashboard', [])
		.factory('DashboardService', DashboardService.factory())
		.controller('DashboardController', DashboardController);
}